module.exports = __webpack_public_path__ + "static/media/preview.684c0480.png";